/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  share.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:27
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

/* 分享模块数据存储 */
const share = {
  state: {
    customerId: '', // 客户id
    goodsId: '', // 商品id
    shopId: '', // 店铺id
    shareToken: "", // 分享模块token，用于登录注册流程
    shareUserId: "", // 分享模块userId，用于登录注册流程
  },
  mutations: {
    SET_CUSTOMER_ID: (state: any, customerId: string) => {
      state.customerId = customerId
    },
    SET_GOODS_ID: (state: any, goodsId: string) => {
      state.goodsId = goodsId
    },
    SET_SHOP_ID: (state: any, shopId: string) => {
      state.shopId = shopId
    },
    SET_SHARE_TOKEN: (state: any, shareToken: string) => {
      state.shareToken = shareToken
    },
    SET_SHARE_USER_ID: (state: any, shareUserId: string) => {
      state.shareUserId = shareUserId
    }
  },
  actions: {
    setCustomerId({ commit }: any,  customerId: string) {
      commit("SET_CUSTOMER_ID", customerId);
    },
    setGoodsId({ commit }: any,  goodsId: string) {
      commit("SET_GOODS_ID", goodsId);
    },
    setShopId({ commit }: any,  shopId: string) {
      commit("SET_SHOP_ID", shopId);
    },
    setShareToken({ commit }: any,  shareToken: string) {
      commit("SET_SHARE_TOKEN", shareToken);
    },
    setShareUserId({ commit }: any,  shareUserId: string) {
      commit("SET_SHARE_USER_ID", shareUserId);
    }
  },
};

export default share;
